import { render, staticRenderFns } from "./DesignerPage.vue?vue&type=template&id=57d92dfc"
import script from "./DesignerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignerPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports